<template>
  <a class="brand-logo" href="javascript:void(0);">
    <h3 class="card-title font-weight-bold mb-1"><img class="width-10-per" :src="`${publicPath}vaults-authlogo.png`"></h3>
  </a>
  <!-- /Brand logo-->
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

